import React__default from 'react';

var useOnClickOutside = function useOnClickOutside(ref, callback) {
  React__default.useEffect(function () {
    var listener = function listener(event) {
      var refs = !Array.isArray(ref) ? [ref] : ref;

      if (refs.some(function (currentRef) {
        return !currentRef.current || currentRef.current.contains(event.target);
      })) {
        return;
      }

      callback(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return function () {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, callback]);
};

export { useOnClickOutside };
//# sourceMappingURL=useOnClickOutside.js.map
